import { c as _c } from "react/compiler-runtime";
import type { MatchLevel } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type ValidationTimelineItemHeaderProps = {
  attribute: string;
  matchLevel: MatchLevel;
};
const matchColors: Record<MatchLevel, string> = {
  no_match: 'text-error',
  could_not_match: 'text-warning',
  exact: 'text-success',
  partial: 'text-warning'
};
const ValidationTimelineItemHeader = t0 => {
  const $ = _c(21);
  const {
    attribute,
    matchLevel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.onboardingDecisionEvent.notVerifiedDetails.fieldValidations"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = attr => {
      const attrMap = {
        phone: () => t(_temp),
        name: () => t(_temp2),
        address: () => t(_temp3),
        dob: () => t(_temp4),
        email: () => t(_temp5),
        ssn: () => t(_temp6),
        document: () => t(_temp7),
        businessName: () => t(_temp8),
        businessTin: () => t(_temp9),
        businessAddress: () => t(_temp10),
        businessBeneficialOwners: () => t(_temp11),
        businessPhoneNumber: () => t(_temp12)
      };
      return attrMap[attr]?.() || attr;
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getAttributeLabel = t2;
  let t3;
  if ($[3] !== t) {
    t3 = level => {
      const levelMap = {
        exact: () => t(_temp13),
        no_match: () => t(_temp14),
        could_not_match: () => t(_temp15),
        partial: () => t(_temp16)
      };
      return levelMap[level]?.() || level;
    };
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getMatchLevelLabel = t3;
  let t4;
  if ($[5] !== attribute || $[6] !== getAttributeLabel) {
    t4 = getAttributeLabel(attribute);
    $[5] = attribute;
    $[6] = getAttributeLabel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <p className="text-label-2">{t4}</p>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = matchColors[matchLevel];
  let t7;
  if ($[10] !== t6) {
    t7 = cx("text-label-2 text-quaternary", t6);
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== getMatchLevelLabel || $[13] !== matchLevel) {
    t8 = getMatchLevelLabel(matchLevel);
    $[12] = getMatchLevelLabel;
    $[13] = matchLevel;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <p className={t7}>{t8}</p>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t9) {
    t10 = <div className="flex flex-row justify-between w-full">{t5}{t9}</div>;
    $[18] = t5;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default ValidationTimelineItemHeader;
function _temp($) {
  return $.attributes.phone;
}
function _temp2($_0) {
  return $_0.attributes.name;
}
function _temp3($_1) {
  return $_1.attributes.address;
}
function _temp4($_2) {
  return $_2.attributes.dob;
}
function _temp5($_3) {
  return $_3.attributes.email;
}
function _temp6($_4) {
  return $_4.attributes.ssn;
}
function _temp7($_5) {
  return $_5.attributes.document;
}
function _temp8($_6) {
  return $_6.attributes.businessName;
}
function _temp9($_7) {
  return $_7.attributes.businessTin;
}
function _temp10($_8) {
  return $_8.attributes.businessAddress;
}
function _temp11($_9) {
  return $_9.attributes.businessBeneficialOwners;
}
function _temp12($_10) {
  return $_10.attributes.businessPhoneNumber;
}
function _temp13($_11) {
  return $_11.matchLevel.exact;
}
function _temp14($_12) {
  return $_12.matchLevel.no_match;
}
function _temp15($_13) {
  return $_13.matchLevel.could_not_match;
}
function _temp16($_14) {
  return $_14.matchLevel.partial;
}